module.exports = __webpack_public_path__ + "img/Report-Misi-WorkValue-Banner0.cc336125.png";